
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { mesAutobind } from '@posco/posco-shared';
import { Accordion, Button } from '@posco/posco-ui-react';


@mesAutobind
@observer
class SnapChartView extends Component {
  //
  static propTypes = {
    onChangeDataType: PropTypes.func,
  };

  render() {
    //
    const {
      children, onChangeDataType,
    } = this.props;

    return (
      <Accordion>
        <Accordion.Title text="Snap UI Chart" />
        <Accordion.Content>
          <Button onClick={onChangeDataType}>차트 데이터 변경</Button>
          {children}
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default SnapChartView;

